import { required } from 'vuelidate/lib/validators';

const validations = {
  title: {
    required,
  },
  zipCode: {
    required,
  },
  dialingCode: {
    required,
  },
  countryId: {
    required,
  },
};

export default validations;